// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"30bce442","783":"2668a9bb","977":"5c336011"}[chunkId] + ".chunk.js";
};